export default function cleanBaseUrl(url) {
    if (!url || typeof url !== 'string') {
        return url;
    }
    
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete('lang');
        return urlObj.toString();
    } catch (error) {
        // If URL parsing fails, handle as relative(./) URL or return original
        try {
            const [baseUrl, queryString] = url.split('?');
            
            if (!queryString) {
                return url; // No query parameters, return original
            }
            
            const params = new URLSearchParams(queryString);
            params.delete('lang');
            
            const cleanedParams = params.toString();
            return cleanedParams ? `${baseUrl}?${cleanedParams}` : baseUrl;
        } catch (fallbackError) {
            // If all parsing fails, return original URL
            return url;
        }
    }
}
